export default __webpack_public_path__ + "static/media/full-gray-arrow-down.e65ed062.svg";